import { render } from "./WaitForOpponentModal.vue?vue&type=template&id=692783e9&scoped=true&ts=true"
import script from "./WaitForOpponentModal.vue?vue&type=script&lang=ts"
export * from "./WaitForOpponentModal.vue?vue&type=script&lang=ts"

import "./WaitForOpponentModal.vue?vue&type=style&index=0&id=692783e9&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692783e9"]])

export default __exports__